import { RdxDevToolsConfig } from '../../types'

export const DEFAULT_DEVTOOLS_CONFIG: RdxDevToolsConfig = {
  enabled: true,
  options: undefined,
}
